export const PURCHASE_TYPE_MAPPINGS = {
  rent_for: "Rent",
  lease_for: "Lease",
  purchase_for: "Buy",
  apply_tpp: "TPP",
  // monthly_fee: "Monthly Fee",
};

export const FILE_TYPE_OPTIONS = {
  retail: "Retail",
  retail_with_tips: "Retail with Tips",
  restaurant_with_tip_adjust: "Restaurant with Tip Adjust",
};

export const CONNECTIVITY_OPTIONS = {
  wifi: "WiFi",
  ip: "IP",
  sim: "Sim",
};

export const PACKAGE_OPTIONS = {
  e_commerce_cart_plus: "E-Commerce Cart Plus",
  web_hosting_professional: "Web Hosting Professional",
  web_hosting_premier: "Web Hosting Premier",
  web_pak_professional: "WebPak Professional",
  web_pak_premier: "WebPak Premier",
  no_equipment: "No Equipment",
  premier_150: "Premier 150",
  premier_250: "Premier 250",
  premier_500: "Premier 500",
};

export const CABLE_LENGTH_OPTIONS = {
  25: "25",
  50: "50",
  100: "100",
};

export const PACKAGE_PRICING_MAPPING = {
  e_commerce_cart_plus: 49.0,
  web_hosting_professional: 59.0,
  web_hosting_premier: 89.0,
  web_pak_professional: 99.0,
  web_pak_premier: 129.0,
};

export const CABLE_LENGTH_PRICING_MAPPING = {
  25: 10,
  50: 20,
  100: 30,
};
